import React, { useState } from "react";
import {
	Card
} from "reactstrap";

export default function StepOne({ setupProgress, setSetupProgress, setErrorMessage }) {

	const grantPermissions = async () => {
		 try {
			const stream = await navigator.mediaDevices.getUserMedia({
				audio: true
			});
			stream.getTracks().forEach((track) => track.stop());
			setSetupProgress(prev => ({
				...prev,
				stepTwo: true
			}));
		} catch (err) {
			setErrorMessage("Microphone permission denied");
		}
	};

	return (
		<Card className="p-4 mb-3 visibility-visible">
			<div className="title mb-4">
				<span className="me-2 step-number">1</span>Grant Microphone Permission
			</div>

			<div className="mb-3 gray-text">
				Allow Access to your microphone to begin the setup process.
			</div>

			<div className="contact-form-btns">
				<button
					type="button"
					className="contact-save-btn btn m-0"
					onClick={grantPermissions}
					disabled={setupProgress.stepTwo}
				>{setupProgress.stepTwo ? "Permission Granted" : "Grant Permission"}</button>
			</div>
		</Card>
	);
};